import moment from 'moment';
import { FirebaseConfig, FirebaseCourseItem } from '../types/types';

export const getRemainingRegistrants = (
  course: FirebaseCourseItem,
  config: FirebaseConfig
) => {
  const uid = moment(course.startMoment).unix().toString();
  return (
    course.maxParticipants! -
    (course.dates && course.dates[uid] && course.dates[uid].length
      ? course.dates[uid].length
      : 0)
  );
};
